// Адреса бэкендов и ключи внешних API — конфигурация транспорта.
export const API_SELLER = window.API_SELLER || import.meta.env.VITE_API_SELLER
export const API_NEWS = window.API_NEWS || import.meta.env.VITE_API_NEWS
export const API_ORDER_CENTER
  = window.API_ORDER_CENTER || import.meta.env.VITE_API_ORDER_CENTER
export const API_EDUCATION = window.API_EDUCATION || import.meta.env.VITE_API_EDUCATION

export const API_2GIS = 'https://catalog.api.2gis.com/3.0'

export const TWO_GIS = {
  API_KEY: '4c64b77c-856d-47bb-b44f-104acde33282',
  DIR_KEY: 'rurpzn1006',
}
